import $ from "jquery";

$(".sw-accordion > dt").on("click", function () {
  var activeClass = "sw-accordion--item-active";
  $(this).toggleClass(activeClass).next("dd").slideToggle(100);
  // Not needed for now.
  // $(this).siblings('.' . activeClass).removeClass(activeClass);
});
